<template>
  <div class="upgrade">
    <el-row class="line button">
      <el-col :span="3">
        <el-button icon="el-icon-circle-plus-outline"
                   size="small" @touchstart="openDialog('add')" @click="openDialog('add')">
          新增机柜
        </el-button>
      </el-col>
      <el-col :span="3" :offset="18" style="text-align: right;padding-right: 10px">
        <el-button @touchstart="exportExcel" @click="exportExcel" size="mini">
          <img src="../../../../assets/images/icon/export.png" style="margin-top: -4px;">
          <span class="text-blue">导出</span>
        </el-button>
      </el-col>
    </el-row>
    <ul v-if="cabinetList.length>0" style="overflow-y: auto;height: 85vh">
      <li :key="item.id" v-for="item in cabinetList">
        <cabinetCard :cabinetList="item" @openDialog="openDialog" @cabinetPage="cabinetPage"></cabinetCard>
      </li>
    </ul>
    <NoData style="text-align: center;margin-top: 10%" v-else></NoData>
    <!-- 新增机柜弹窗-->
    <function-dialog-component
      :close-click="false"
      :dialog-title="title"
      :dialogVisible.sync="visible"
      @dialogClose="dialogClose"
      center
      width="50vw">
      <div slot="content"
           class="dialog-padding"
           style="height: 55vh;overflow-y: auto">
        <el-row>
          <el-col :span="4" style="text-align: right;height: 30px;line-height: 30px;margin-right: 10px">机柜名称：</el-col>
          <el-col :span="18">
            <el-input v-model="form.controlModelName" clearable size="mini"
                      style="height: 30px;line-height: 30px;width: 200px" placeholder="请输入机柜名称"/>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="4" style="text-align: right;height: 30px;line-height: 30px;margin-right: 10px">选择空间：</el-col>
          <el-col :span="18">
            <el-row>
              <el-col :lg="8" :md="10" :sm="15" :xl="8" :xs="24" style="margin-top: 5px;">
                <el-cascader
                  :disabled="form.allSpaceChecked"
                  :options="spaceTree"
                  @change="changeSpace"
                  change-on-select="true"
                  clearable
                  placeholder="请选择空间"
                  size="mini"
                  style="width: 200px"
                  v-model="form.spaceId">
                </el-cascader>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="4" style="text-align: right;height: 30px;line-height: 30px;margin-right: 10px">额定功率：</el-col>
          <el-col :span="18">
            <el-input v-model="form.powerValue" clearable size="mini"
                      style="height: 30px;line-height: 30px;width: 200px" placeholder="请输入额定功率"/>
            KW
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="4" style="text-align: right;height: 30px;line-height: 30px;margin-right: 10px">设备信息：</el-col>
          <el-col :span="19">
            <el-row
              style="display: flex;align-items: center;flex-direction: column;width: 100%;height: 30vh;overflow-y: auto;border: #0B3B66 1px solid;">
              <el-col :span="23">
                <div style="margin-top: 10px">功率：</div>
                <div style="height: 20vh;width: 95%;overflow-y: auto;border: #0B3B66 1px solid;margin: 10px 0 10px 0">
                  <el-row style="margin: 20px 0 0 20px" v-for="(item,index) in form.deviceSettingList.power"
                          :key="index">
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changeDevice(item)"
                        placeholder="可选择设备"
                        size="mini"
                        style="width: 95%;"
                        v-model="form.deviceSettingList.power[index].deviceId">
                        <el-option
                          :key="device.id"
                          :label="device.name"
                          :value="device.id"
                          v-for="device in deviceList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changePoint(form.deviceSettingList.power,index)"
                        placeholder="可选择测点"
                        size="mini"
                        style="width: 95%;"
                        v-model="item.pointId">
                        <el-option
                          :key="index"
                          :label="point.name"
                          :value="point.id"
                          v-for="(point,index) in item.pointList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="5" :md="5" :sm="5" :xl="5" :xs="24">
                      <el-button @touchstart="addDeviceSettingInfo('power')" @click="addDeviceSettingInfo('power')" type="primary" size="mini"
                                 style="margin: 0 0 0 20px"
                                 icon="el-icon-plus"></el-button>
                      <el-button @touchstart="delDeviceSettingInfo('power',index)" @click="delDeviceSettingInfo('power',index)" type="primary" size="mini"
                                 icon="el-icon-minus"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="23">
                <div style="margin-top: 10px">A路电流：</div>
                <div style="height: 20vh;width: 95%;overflow-y: auto;border: #0B3B66 1px solid;margin: 10px 0 10px 0">
                  <el-row style="margin: 20px 0 0 20px" v-for="(item,index) in form.deviceSettingList.aelec"
                          :key="index">
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changeDevice(item)"
                        placeholder="可选择设备"
                        size="mini"
                        value-key="item"
                        style="width: 95%;"
                        v-model="form.deviceSettingList.aelec[index].deviceId">
                        <el-option
                          :key="device.id"
                          :label="device.name"
                          :value="device.id"
                          v-for="device in deviceList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changePoint(form.deviceSettingList.aelec,index)"
                        placeholder="可选择测点"
                        size="mini"
                        style="width: 95%;"
                        v-model="item.pointId">
                        <el-option
                          :key="point.id"
                          :label="point.name"
                          :value="point.id"
                          v-for="point in item.pointList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="5" :md="5" :sm="5" :xl="5" :xs="24">
                      <el-button @touchstart="addDeviceSettingInfo('aelec')" @click="addDeviceSettingInfo('aelec')" type="primary" size="mini"
                                 style="margin: 0 0 0 20px"
                                 icon="el-icon-plus"></el-button>
                      <el-button @touchstart="delDeviceSettingInfo('aelec',index)" @click="delDeviceSettingInfo('aelec',index)" type="primary" size="mini"
                                 icon="el-icon-minus"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="23">
                <div style="margin-top: 10px">B路电流：</div>
                <div style="height: 20vh;width: 95%;overflow-y: auto;border: #0B3B66 1px solid;margin: 10px 0 10px 0">
                  <el-row style="margin: 20px 0 0 20px" v-for="(item,index) in form.deviceSettingList.belec"
                          :key="index">
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changeDevice(item)"
                        placeholder="可选择设备"
                        size="mini"
                        value-key="item"
                        style="width: 95%;"
                        v-model="form.deviceSettingList.belec[index].deviceId">
                        <el-option
                          :key="device.id"
                          :label="device.name"
                          :value="device.id"
                          v-for="device in deviceList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changePoint(form.deviceSettingList.belec,index)"
                        placeholder="可选择测点"
                        size="mini"
                        style="width: 95%;"
                        v-model="item.pointId">
                        <el-option
                          :key="point.id"
                          :label="point.name"
                          :value="point.id"
                          v-for="point in item.pointList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="5" :md="5" :sm="5" :xl="5" :xs="24">
                      <el-button @touchstart="addDeviceSettingInfo('belec')" @click="addDeviceSettingInfo('belec')" type="primary" size="mini"
                                 style="margin: 0 0 0 20px"
                                 icon="el-icon-plus"></el-button>
                      <el-button @touchstart="delDeviceSettingInfo('belec',index)" @click="delDeviceSettingInfo('belec',index)" type="primary" size="mini"
                                 icon="el-icon-minus"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="23">
                <div style="margin-top: 10px">能耗：</div>
                <div style="height: 20vh;width: 95%;overflow-y: auto;border: #0B3B66 1px solid;margin: 10px 0 10px 0">
                  <el-row style="margin: 20px 0 0 20px" v-for="(item,index) in form.deviceSettingList.energy"
                          :key="index">
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changeDevice(item)"
                        placeholder="可选择设备"
                        size="mini"
                        value-key="item"
                        style="width: 95%;"
                        v-model="form.deviceSettingList.energy[index].deviceId">
                        <el-option
                          :key="device.id"
                          :label="device.name"
                          :value="device.id"
                          v-for="device in deviceList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="24">
                      <el-select
                        @change="changePoint(form.deviceSettingList.energy,index)"
                        placeholder="可选择测点"
                        size="mini"
                        style="width: 95%;"
                        v-model="item.pointId">
                        <el-option
                          :key="point.id"
                          :label="point.name"
                          :value="point.id"
                          v-for="point in item.pointList">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :lg="5" :md="5" :sm="5" :xl="5" :xs="24">
                      <el-button @touchstart="addDeviceSettingInfo('energy')" @click="addDeviceSettingInfo('energy')" type="primary" size="mini"
                                 style="margin: 0 0 0 20px"
                                 icon="el-icon-plus"></el-button>
                      <el-button @touchstart="delDeviceSettingInfo('energy',index)" @click="delDeviceSettingInfo('energy',index)" type="primary" size="mini"
                                 icon="el-icon-minus"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="dialogClose" @click="dialogClose" size="mini">关 闭</el-button>
        <el-button @touchstart="commit" @click="commit" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
    <!--   导出弹框-->
    <function-dialog-component
      :close-click="false"
      dialog-title="请选择要导出时间段"
      :dialogVisible.sync="exportVisible"
      @dialogClose="exportExcel"
      center
      width="30vw">
      <div slot="content"
           style="padding: 20px 30px 20px 0;height: 10vh;text-align: center">
        <div style="width: 100%;margin-bottom: 10px;margin-top: 10px">
          选择时间：
          <el-date-picker
            v-model="monthTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin:20px 0 15px 0;">
        <el-button @touchstart="exportExcel" @click="exportExcel" size="mini">关 闭</el-button>
        <el-button @touchstart="openExportDialog" @click="openExportDialog" :loading="isDownload" size="mini" type="primary">确 定</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";
import NoData from "@/components/NoData";
import cabinetCard from "@/components/component/cabinetCard"
import {listByDeviceId} from "@/network/device-measuring-point";
import {cabinetPage, saveCabinet, updateCabinet, cabinetToExcel} from "@/network/cabinet-manage";
import {getDeviceList, getDeviceInfoById} from "@/network/device-info"
import {dateFtt} from '@/utils/tool'
import '@/assets/css/pickerStyle.css'

export default {
  name: "AlarmUpgrade",
  components: {
    FunctionDialogComponent, NoData, cabinetCard
  },
  inject: ['reload'],
  data() {
    return {
      // 导出状态
      exportVisible: false,
      // 导出时间
      monthTime: '',
      // 导出按钮状态
      isDownload: false,
      visible: false,
      operation: '',
      title: '新增机柜',
      // 弹窗类型
      dialogType: 'add',
      // 空间树
      spaceTree: [{
        value: '',
        label: ''
      }],
      // 机柜列表
      cabinetList: [],
      // 分页获取机柜列表参数
      pageParam: {
        pageCurrent: 1,
        pageSize: 999
      },
      form: {
        id: '',
        spaceId: '',
        // 机柜名称
        controlModelName: '',
        // 额定功率
        powerValue: '',
        // 设备信息列表
        deviceSettingList: {power: [], aelec: [], belec: [], energy: []}
      },
      // 设备列表
      deviceList: [],
      // 测点列表
      pointList: [],
      // 设备详情
      deviceInfo: '',
      saveTimer: null
    }
  },
  created() {
    // 获取机柜列表
    this.cabinetPage(this.pageParam)
    // 初始化设备信息
    this.initDeviceSettingList()
    this.getSpaceTreeData();
  },
  destroyed() {
    clearInterval(this.saveTimer)
    this.saveTimer = null
  },
  methods: {
    // 改变空间列表
    changeSpace() {
      this.deviceList = []
      this.pointList = []
      this.initDeviceSettingList()
      this.$forceUpdate()
      this.getDeviceList(this.form.spaceId[this.form.spaceId.length - 1])
    },
    initDeviceSettingList() {
      this.form.deviceSettingList = {power: [], aelec: [], belec: [], energy: []}
      let deviceSettingRow = {
        deviceId: '',
        pointId: '',
        pointCode: '',
        deviceName: '',
        pointName: '',
        pointList: ''
      };
      let deviceSettingRow1 = {
        deviceId: '',
        pointId: '',
        pointCode: '',
        deviceName: '',
        pointName: '',
        pointList: ''
      };
      let deviceSettingRow2 = {
        deviceId: '',
        pointId: '',
        pointCode: '',
        deviceName: '',
        pointName: '',
        pointList: ''
      };
      let deviceSettingRow3 = {
        deviceId: '',
        pointId: '',
        pointCode: '',
        deviceName: '',
        pointName: '',
        pointList: ''
      };
      this.form.deviceSettingList.power.push(deviceSettingRow)
      this.form.deviceSettingList.aelec.push(deviceSettingRow1)
      this.form.deviceSettingList.belec.push(deviceSettingRow2)
      this.form.deviceSettingList.energy.push(deviceSettingRow3)
    },
    openExportDialog() {
      this.isDownload = true;
      cabinetToExcel(dateFtt('yyyy-MM-dd hh:mm:ss', this.monthTime[0]), dateFtt('yyyy-MM-dd hh:mm:ss', this.monthTime[1])).then(() => {
        this.isDownload = false
        this.exportVisible = false
        this.$message.info('文件生成中，稍后请前往下载列表中下载文件!')
      }).catch(() => {
        this.isDownload = false;
        this.exportVisible = false
        this.$message.error("下载失败");
      });
    },
    // 导出
    exportExcel() {
      this.exportVisible = !this.exportVisible;
    },
    // 根据空间id获取空间信息
    async getDeviceList(spaceId) {
      await getDeviceList(spaceId).then(res => {
        if (res.code === 0 && res.data !== null) {
          this.deviceList = res.data
        }
      })
    },
    //设备选择
    changeDevice(item) {
      this.getPointList(item)
    },
    // 测点改变
    changePoint(list, index) {
      list[index].pointList.forEach(item => {
        if (list[index].pointId === item.id) {
          list[index].pointCode = item.code
          this.$forceUpdate()
        }
      })
    },
    // 根据设备获取测点
    getPointList(item) {
      this.getPoint(item);
    },
    async getPoint(item) {
      let that = this
      await listByDeviceId(item.deviceId).then(res => {
        if (res.code === 0) {
          item.pointList = []
          if (res.data.length > 0) {
            item.pointList = res.data
            that.$forceUpdate()
          }
        }
      })
    },
    // 添加一行设备信息
    addDeviceSettingInfo(tag) {
      let deviceSettingRow = {
        deviceId: '',
        pointId: '',
        pointCode: '',
        deviceName: '',
        pointName: '',
        pointList: ''
      };
      switch ( tag ) {
        case 'power':
          this.form.deviceSettingList.power.push(deviceSettingRow)
          break;
        case 'aelec':
          this.form.deviceSettingList.aelec.push(deviceSettingRow)
          break;
        case 'belec':
          this.form.deviceSettingList.belec.push(deviceSettingRow)
          break;
        case 'energy':
          this.form.deviceSettingList.energy.push(deviceSettingRow)
          break;
      }
    },
    // 删除指定行设备信息
    delDeviceSettingInfo(tag, index) {
      switch ( tag ) {
        case 'power':
          this.deletePoint(this.form.deviceSettingList.power, index)
          break;
        case 'aelec':
          this.deletePoint(this.form.deviceSettingList.aelec, index)
          break;
        case 'belec':
          this.deletePoint(this.form.deviceSettingList.belec, index)
          break;
        case 'energy':
          this.deletePoint(this.form.deviceSettingList.energy, index)
          break;
      }
    },
    deletePoint(device, index) {
      if (device.length > 1) {
        device.splice(index, 1)
      } else {
        this.$message.info("请至少保留一行设备信息！！")
      }
    },
    openDialog(operation, data) {
      this.operation = operation;
      if (operation === 'add') {
        this.title = '新增机柜'
        this.dialogType = 'add'
        this.visible = true;
      } else {
        console.log(data)
        this.title = '编辑机柜'
        this.dialogType = 'edit'
        this.form.spaceId = data.spaceId
        this.form.powerValue = data.ratedPower
        this.form.controlModelName = data.name
        this.form.deviceSettingList = data.equipmentCabinetDetails
        this.form.id = data.id
        this.getDeviceList(this.form.spaceId).then(() => {
          this.editCabinetForm(this.form.deviceSettingList.power,'power')
          this.editCabinetForm(this.form.deviceSettingList.aelec,'aelec')
          this.editCabinetForm(this.form.deviceSettingList.belec,'belec')
          this.editCabinetForm(this.form.deviceSettingList.energy,'energy')
          this.visible = true;
        })
      }
    },
    // 修改机柜赋值
    editCabinetForm(itemObject,tag) {
      if (itemObject !== null && itemObject.length > 0) {
        for( const item of itemObject ) {
          // 封装每个设备测点集合
          listByDeviceId(item.deviceId).then(res => {
            if (res.code === 0) {
              if (res.data.length > 0) {
                item.pointList = res.data
              }
            }
          })
        }
      } else {
        let deviceSettingRow = {
          deviceId: '',
          pointId: '',
          pointCode: '',
          deviceName: '',
          pointName: '',
          pointList: ''
        };
        switch ( tag ) {
          case 'power':
            this.form.deviceSettingList.power = []
            this.form.deviceSettingList.power.push(deviceSettingRow)
            break;
          case 'aelec':
            this.form.deviceSettingList.aelec = []
            this.form.deviceSettingList.aelec.push(deviceSettingRow)
            break;
          case 'belec':
            this.form.deviceSettingList.belec = []
            this.form.deviceSettingList.belec.push(deviceSettingRow)
            break;
          case 'energy':
            this.form.deviceSettingList.energy = []
            this.form.deviceSettingList.energy.push(deviceSettingRow)
            break;
        }

        this.$forceUpdate()
      }
    },
    //获取级联空间
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    // 分页获取机柜列表
    cabinetPage(pageParam) {
      cabinetPage(pageParam).then(res => {
        if (res.code === 0 && res.data !== null) {
          this.cabinetList = res.data.records
        }
      })
    },
    //数据保存
    async commit() {
      console.log(this.form.deviceSettingList)
      if (this.form.controlModelName === '') {
        this.$message.info("请输入机柜名称！")
        return;
      } else if (this.form.powerValue === '') {
        this.$message.info("请输入额定功率！")
        return;
      } else if (this.form.spaceId.length === 0 || this.form.spaceId === '') {
        this.$message.info("请选择空间！")
        return;
      }
      let deviceListCopy = this.form.deviceSettingList
      let power = this.checkForm(deviceListCopy.power)
      let aelec = this.checkForm(deviceListCopy.aelec)
      let belec = this.checkForm(deviceListCopy.belec)
      let energy = this.checkForm(deviceListCopy.energy)
      // 获取设备名称和测点名称后重新赋值
      this.form.deviceSettingList.power = power
      this.form.deviceSettingList.aelec = aelec
      this.form.deviceSettingList.belec = belec
      this.form.deviceSettingList.energy = energy
      this.saveTimer = setInterval(() => {
        // 轮询判断是否成功赋值
        // 线程不能同步变量赋值问题
        if ((this.form.deviceSettingList.power[0].deviceName !== '' || this.form.deviceSettingList.aelec[0].deviceName !== ''
            || this.form.deviceSettingList.belec[0].deviceName !== '' || this.form.deviceSettingList.energy[0].deviceName !== '')
          && this.dialogType === 'add') {
          // 获取空间名称
          let formData = {
            "id": this.form.id,
            "name": this.form.controlModelName,
            "ratedPower": this.form.powerValue,
            "spaceId": this.form.spaceId[this.form.spaceId.length - 1],
            "equipmentCabinetDetails": this.form.deviceSettingList
          }
          this.saveCabinet(formData)
          clearInterval(this.saveTimer)
          this.saveTimer = null
        } else if ((this.form.deviceSettingList.power[0].deviceName !== '' || this.form.deviceSettingList.aelec[0].deviceName !== ''
            || this.form.deviceSettingList.belec[0].deviceName !== '' || this.form.deviceSettingList.energy[0].deviceName !== '')
          && this.dialogType === 'edit') {
          // 获取空间名称
          let formData = {
            "id": this.form.id,
            "name": this.form.controlModelName,
            "ratedPower": this.form.powerValue,
            "spaceId": this.form.spaceId.length > 8 ? this.form.spaceId : this.form.spaceId[this.form.spaceId.length - 1],
            "equipmentCabinetDetails": this.form.deviceSettingList
          }
          this.updateCabinet(formData)
          clearInterval(this.saveTimer)
          this.saveTimer = null
        }
      }, 1000)
    },
    checkForm(deviceListCopy) {
      deviceListCopy.forEach((item, index) => {
        if (item.deviceId !== '' && item.deviceId !== null) {
          getDeviceInfoById(item.deviceId).then(res => {
            if (res.code === 0 && res.data !== null) {
              deviceListCopy[index].deviceName = res.data[0].name
              this.getPoint(item).then(() => {
                item.pointList.forEach(point => {
                  if (point.id === item.pointId) {
                    deviceListCopy[index].pointName = point.name
                  }
                })
              })
            }
          })
        }
      })
      return deviceListCopy
    },
    // 保存机柜信息
    saveCabinet(form) {
      saveCabinet(form).then(res => {
        if (res.code === 0) {
          this.$message.success("新增机柜信息成功！")
          this.cabinetPage(this.pageParam)
          // 清空弹窗表格数据
          this.clearDialogInfo()
          this.visible = false
        } else {
          this.$message.error("新增机柜信息失败！")
        }
      })
    },
    // 根据id修改机柜
    updateCabinet(form) {
      updateCabinet(form).then(res => {
        if (res.code === 0) {
          this.$message.success("修改机柜信息成功！")
          this.cabinetPage(this.pageParam)
          // 清空弹窗表格数据
          this.clearDialogInfo()
          this.visible = false
        } else {
          this.$message.error("修改机柜信息失败！")
        }
      })
    },
    clearDialogInfo() {
      this.form.controlModelName = ''
      this.form.powerValue = ''
      this.form.spaceId = []
      this.form.id = ''
      this.initDeviceSettingList()
    },
    dialogClose() {
      this.visible = false;
      // 清空弹窗表格数据
      this.clearDialogInfo()
    }
  }
}
</script>

<style scoped>
.upgrade {
  padding: 15px 10px;
}

.upgrade li {
  list-style: none;
  width: 500px;
  height: 378px;
  float: left;
  margin: 10px 10px;
  padding: 30px 40px 30px 40px;
  background-color: rgba(41, 155, 255, .1);
}
</style>
